import styles from './AddCreatorModal.module.css';
import { creatorbase } from '@round/api';
import { Button, lucideIcons } from '@round/creatorbase-ui';
import { platforms, platformIcons, platformLabels } from 'Modules/Plans/helpers';

const { PlusIcon } = lucideIcons;

type Props = {
    activePlatforms: creatorbase.Platform[];
    onPlatformSelect: (platform: creatorbase.Platform) => void;
};

const PlatformSelect = ({ activePlatforms, onPlatformSelect }: Props) => {
    // youtube is not supported yet
    const availablePlatforms = platforms.filter((p) => !activePlatforms.includes(p) && p !== 'youtube');
    return (
        <div className={styles.platforms}>
            {availablePlatforms.map((platform) => {
                const Icon = platformIcons[platform];
                return (
                    <Button key={platform} variant="outline" size="xs" onClick={() => onPlatformSelect(platform)}>
                        <Icon />
                        <PlusIcon />
                        {platformLabels[platform]}
                    </Button>
                );
            })}
        </div>
    );
};

export default PlatformSelect;
